// extracted by mini-css-extract-plugin
export default {"header":"Header_header__H5Wt6","logo":"Header_logo__nkrkd","image":"Header_image__0WVeO","title":"Header_title__Xj99e","subtitle":"Header_subtitle__LlP46"};